export const getBaseUrl = () => {
  const envApiUrl = import.meta.env.VITE_API_URL?.trim();

  if (envApiUrl) {
    return envApiUrl.replace(/\/$/, '');
  }

  const { protocol, hostname } = window.location;
  const isIpAddress = /^(localhost|127\.0\.0\.1|\d{1,3}(?:\.\d{1,3}){3})$/.test(hostname);

  if (import.meta.env.DEV || isIpAddress) {
    return `${protocol}//${hostname}:5017`;
  }

  return `${window.location.origin}/api`;
};
